import { RouteRecordRaw } from "vue-router";

const Customers: RouteRecordRaw = {
  path: "customers",
  component: () => import("@/views/customers/index.vue"),
  meta: {
    title: "العملاء",
  },
  children: [
    {
      path: "",
      alias: "index",
      name: "index-customers",
      component: () => import("@/views/customers/pages/index.vue"),
      meta: {
        pageId: 18010400,
        role: "view",
        title: "العملاء",
      },
    },
    {
      path: "add",
      name: "add-customer",
      component: () => import("@/views/customers/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "add",
        title: "AddNew",
      },
    },
    {
      path: "Edit/:Id",
      props: true,
      name: "edit-customer",
      component: () => import("@/views/customers/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "edit",
        title: "Edit",
      },
    },
  ],
};

export default Customers;
